import { CaretDown } from "phosphor-react"
import React, { useEffect, useState } from "react"
import Collapse from "react-collapse-animated"

export default ({ children, label, className="", transitionDuration="0.2s", initiallyOpen, onStateChange }) => {
    const [isOpen, setIsOpen] = useState(initiallyOpen || false)

    useEffect(() => {
        if(onStateChange)
            onStateChange(isOpen)
    }, [isOpen])

    return <div className={"collapsible " + className}>
        <label onClick={() => setIsOpen(!isOpen)}>
            {label}
            <CaretDown size="14" style={{transform: isOpen ? "rotate(180deg)" : "rotate(0)", transitionDuration: transitionDuration}} />
        </label>
        <div className="collapsible__content">
            <Collapse open={isOpen} transitionDuration={transitionDuration}>
                {children}
            </Collapse>
        </div>
    </div>
}